import { ProjectTemplateList } from './ProjectTemplateList'
import { publicProjectTemplateHelper } from '@/common/src/helpers'
import { PROJECT_TEMPLATE_TYPE } from '../ProjectTemplateType'
import { usePublicProjectTemplateSearch } from '@/queries/projectTemplates'
import { useDebouncedValue } from '@/hooks/useDebouncedValue'
import { useMemo } from 'react'

const type = PROJECT_TEMPLATE_TYPE.PUBLIC

function compareDownloads(a, b) {
  return b.downloads - a.downloads
}

export const PublicProjectTemplateList = ({
  searchText = '',
  selectedCategory = publicProjectTemplateHelper.ALL_CATEGORY,
  ...rest
}) => {
  const debouncedPublicSearch = useDebouncedValue(searchText, 500)

  const { data: templates, isLoading } = usePublicProjectTemplateSearch({ text: debouncedPublicSearch })
  const filteredTemplates = useMemo(() => {
    if (!templates) return []
    if (selectedCategory === publicProjectTemplateHelper.ALL_CATEGORY) {
      return templates.sort(compareDownloads)
    }
    return templates.filter(t => t.category === selectedCategory).sort(compareDownloads)
  }, [templates, selectedCategory])

  return <ProjectTemplateList type={type} templates={filteredTemplates} loading={isLoading} {...rest} />
}
